import { Object3D } from 'three';
import { BatchedRenderer, QuarksUtil } from 'three.quarks';
import { GameResourcesPackage } from '../../../../resources/GameResourcesPackage';
import { clone } from 'three/examples/jsm/utils/SkeletonUtils.js';

export class ElectricityParticle extends Object3D {
    private particle: Object3D;

    public constructor(
        gameResources: GameResourcesPackage,
        batchRenderer: BatchedRenderer
    ) {
        super();
        this.particle = clone(gameResources.assets_game_particles_lightning_thjson);
        this.particle.position.set(0, 0.5, 0);
        this.particle.scale.multiplyScalar(1.5);
        QuarksUtil.setAutoDestroy(this.particle, false);
        QuarksUtil.addToBatchRenderer(this.particle, batchRenderer);
        QuarksUtil.play(this.particle);
        this.add(this.particle);
    }

    public destroy(): void {
        QuarksUtil.stop(this.particle);
        this.remove(this.particle);
    }
}
